module.exports = __webpack_public_path__ + "img/QRCode.734afa43.png";